"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimateUnmount = useAnimateUnmount;
exports.default = void 0;

var _react = require("react");

function useAnimateUnmount(ref, onTransitionEnd) {
  const [transitionState, setTransitionState] = (0, _react.useState)('mounting');

  const animateUnmount = () => {
    if (transitionState === 'mounted') {
      setTransitionState('unmounting');
    }
  };

  (0, _react.useEffect)(() => {
    const transitionEl = ref.current;

    const handleEvent = () => {
      if (transitionState === 'mounting') {
        setTransitionState('mounted');
      }

      if (transitionState === 'unmounting') {
        setTransitionState('unmounted');
      }
    };

    if (transitionEl) {
      if (transitionState === 'mounting') {
        setTransitionState('mounted');
      }

      transitionEl.addEventListener('transitionend', handleEvent);
    }

    if (transitionState === 'unmounted' && typeof onTransitionEnd === 'function') {
      onTransitionEnd();
    }

    return () => {
      if (transitionEl) {
        transitionEl.removeEventListener('transitionend', handleEvent);
      }
    };
  }, [onTransitionEnd, ref, transitionState]);
  return [transitionState, animateUnmount];
}

var _default = useAnimateUnmount;
exports.default = _default;
//# sourceMappingURL=useAnimateUnmount.js.map